import type { CommercialAddModulesResult } from "@itaas/pep-contracts";

interface TrialModulesAddedPanelProps {
  result: CommercialAddModulesResult;
  onContinue: () => void;
}

export function TrialModulesAddedPanel({ result, onContinue }: TrialModulesAddedPanelProps) {
  const added = result.modulesAdded.filter((m) => m !== "iam");
  const already = result.alreadyLicensed.filter((m) => m !== "iam");

  return (
    <div className="card border-0 shadow-sm p-4 p-md-5">
      <div className="text-center mb-4">
        <div className="display-6 text-success mb-2">✓</div>
        <h2 className="h4 fw-bold">
          {added.length ? "Modules activés" : "Modules déjà actifs"}
        </h2>
        <p className="text-secondary mb-0">
          Organisation <strong>{result.tenantName || result.tenantSlug}</strong>
        </p>
      </div>

      {added.length > 0 && (
        <div className="alert alert-success mb-3" role="status">
          <strong>Nouveaux modules :</strong>{" "}
          {added.map((m) => m.toUpperCase()).join(", ")}
        </div>
      )}

      {already.length > 0 && (
        <p className="small text-secondary text-center mb-3">
          Déjà licenciés (inchangés) : {already.map((m) => m.toUpperCase()).join(", ")}
        </p>
      )}

      {result.trialEndsAt && added.length > 0 && (
        <p className="small text-center text-secondary mb-4">
          Fin d&apos;essai :{" "}
          <strong>{new Date(result.trialEndsAt).toLocaleDateString("fr-FR")}</strong>
        </p>
      )}

      <div className="text-center">
        <button type="button" className="btn btn-primary btn-lg" onClick={onContinue}>
          Ouvrir la Suite ITaaS →
        </button>
      </div>
    </div>
  );
}
